import React from "react"

export default function About(){
    return (
        <div className="about">
            <h3>About</h3>
            <p>Dedicated and detail-oriented software engineer with a passion for crafting innovative web solutions. Proven success in developing and implementing impactful web applications. Looking to bring my skills to a tech company with global reach,  leveraging my skills to drive excellence in web development.</p>
        </div>
    )
}